import { useCallback, useEffect, useRef, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { useQuery } from 'react-query';
import axios from '~/api/axios';
import { auth } from '~/api/auth';

export const useUserActivity = () => {
  const [hasAuthToken, setHasAuthToken] = useState(!!auth.getToken());

  useEffect(() => {
    const setToken = () => setHasAuthToken(!!auth.getToken());

    window.addEventListener(auth.tokenLocalStorageKey, setToken);
    return () => {
      window.removeEventListener(auth.tokenLocalStorageKey, setToken);
    };
  }, []);

  const lastActivity = useRef<number>(Date.now());
  useQuery(
    'ping',
    () => {
      // if (DEV || Date.now() - lastActivity?.current <= DELAY_MS) {
      return axios.post('/user/ping');
      // }
      // return Promise.resolve(null);
    },
    {
      refetchInterval: DELAY_MS,
      refetchIntervalInBackground: true,
      retry: false,
      notifyOnChangeProps: ['error'],
      onError: () => {},
      enabled: hasAuthToken,
    }
  );

  const debouncedSetTime = useDebouncedCallback(() => {
    const now = Date.now();
    lastActivity.current = now;
    localStorage.setItem('lastActivity', now.toString());
    window.dispatchEvent(new Event('local-storage'));
  }, 1000);
  const onEvent = useCallback(() => {
    debouncedSetTime();
  }, [debouncedSetTime]);

  return { onEvent };
};

const DELAY_MS = 60000; // ONE MINUTE
const DEV = process.env.NODE_ENV === 'development';
